import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './BloqueadosIA.css';

function BloqueadosIA() {
  const [bloqueados, setBloqueados] = useState([]);
  const [novoNumero, setNovoNumero] = useState('');
  const [leads, setLeads] = useState([]);
  const [carregando, setCarregando] = useState(false);

  // [TAG] estados para bloqueio por TAG
  const [tags, setTags] = useState([]);
  const [tagSelecionada, setTagSelecionada] = useState('');
  const [previewTag, setPreviewTag] = useState(null); // { total, leads: [...] }
  const [carregandoTagPreview, setCarregandoTagPreview] = useState(false);
  const [bloqueandoTag, setBloqueandoTag] = useState(false);

  const normalizarTelefone = (numero) => {
    const limpo = (numero || '').replace(/\D/g, '');
    if (limpo.length === 11) return '55' + limpo;
    return limpo;
  };

  const formatarTelefoneBR = (numero) => {
    const limpo = (numero || '').replace(/\D/g, '');
    if (limpo.length === 11) return limpo.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    if (limpo.length === 13 && limpo.startsWith('55')) {
      const n = limpo.slice(2);
      return n.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    }
    return numero || '---';
  };

  const formatarDataBrasileira = (dataISO) => {
    if (!dataISO) return 'Data inválida';
    const data = new Date(dataISO);
    return isNaN(data.getTime())
      ? 'Data inválida'
      : data.toLocaleString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
  };

  const carregarBloqueados = async () => {
    setCarregando(true);
    try {
      const res = await axios.get('https://welaunchyou.com.br/crm-wly/api/openai/numeros_bloqueados.php', {
        withCredentials: true
      });
      if (res.data?.success && Array.isArray(res.data.lista)) {
        setBloqueados(res.data.lista);
      } else {
        setBloqueados([]);
      }
    } catch (error) {
      console.error('Erro ao listar números bloqueados', error);
    } finally {
      setCarregando(false);
    }
  };

  const carregarLeads = async () => {
    try {
      const res = await axios.get('https://welaunchyou.com.br/crm-wly/getLeads.php', {
        withCredentials: true
      });
      if (Array.isArray(res.data)) setLeads(res.data);
    } catch (err) {
      console.error('Erro ao carregar leads:', err);
    }
  };

  // [TAG] carrega a lista de TAGs do usuário
  const carregarTags = async () => {
    try {
      const res = await axios.get('https://welaunchyou.com.br/crm-wly/tags-block.php', {
        withCredentials: true
      });
      // Esperado: [{id, nome}, ...]
      if (Array.isArray(res.data)) setTags(res.data);
    } catch (err) {
      console.error('Erro ao carregar tags:', err);
    }
  };

  const handleAdicionar = async () => {
    const telefone = normalizarTelefone(novoNumero);
    if (telefone.length < 10) return alert('Número inválido.');
    try {
      await axios.post(
        'https://welaunchyou.com.br/crm-wly/api/openai/numeros_bloqueados.php',
        { telefone, acao: 'bloquear' },
        { withCredentials: true }
      );
      setNovoNumero('');
      carregarBloqueados();
    } catch (err) {
      alert('Erro ao bloquear número.');
    }
  };

  const handleRemover = async (telefone) => {
    if (!window.confirm('Remover esse número da lista de bloqueados?')) return;
    try {
      await axios.post(
        'https://welaunchyou.com.br/crm-wly/api/openai/numeros_bloqueados.php',
        { telefone, acao: 'desbloquear' },
        { withCredentials: true }
      );
      carregarBloqueados();
    } catch (err) {
      alert('Erro ao remover número.');
    }
  };

  // [TAG] Pré-visualização dos leads de uma TAG que seriam bloqueados
  const previewBloqueioPorTag = async (tagId) => {
    setPreviewTag(null);
    if (!tagId) return;

    setCarregandoTagPreview(true);
    try {
      const res = await axios.get('https://welaunchyou.com.br/crm-wly/api/openai/bloquear_por_tag.php', {
        withCredentials: true,
        params: { tag_id: tagId, preview: 1 }
      });
      if (res.data?.success) {
        setPreviewTag({ total: res.data.total || 0, leads: res.data.leads || [] });
      } else {
        setPreviewTag({ total: 0, leads: [] });
      }
    } catch (err) {
      console.error('Erro ao obter prévia de bloqueio por TAG:', err);
      setPreviewTag({ total: 0, leads: [] });
    } finally {
      setCarregandoTagPreview(false);
    }
  };

  // [TAG] Executa o bloqueio em massa por TAG
  const bloquearTodosDaTag = async () => {
    if (!tagSelecionada) return alert('Selecione uma TAG.');
    if (!previewTag || previewTag.total === 0) return alert('Não há leads válidos para bloquear nesta TAG.');
    if (!window.confirm(`Bloquear ${previewTag.total} lead(s) desta TAG?`)) return;

    setBloqueandoTag(true);
    try {
      const res = await axios.post(
        'https://welaunchyou.com.br/crm-wly/api/openai/bloquear_por_tag.php',
        { tag_id: parseInt(tagSelecionada, 10) },
        { withCredentials: true }
      );

      if (res.data?.success) {
        alert(`Bloqueados inseridos: ${res.data.bloqueados_inseridos} / Processados: ${res.data.processados}`);
        await carregarBloqueados();
        setPreviewTag(null);
      } else {
        alert(res.data?.message || 'Erro ao bloquear por TAG.');
      }
    } catch (err) {
      console.error('Erro ao bloquear por TAG:', err);
      alert('Erro ao bloquear por TAG.');
    } finally {
      setBloqueandoTag(false);
    }
  };

  useEffect(() => {
    carregarBloqueados();
    carregarLeads();
    carregarTags();
  }, []);

  // Para cruzar lead->bloqueado, compare telefones normalizados
  const encontrarLeadPorTelefone = (telBloq) => {
    const nBloq = normalizarTelefone(telBloq);
    return leads.find((l) => normalizarTelefone(l.telefone) === nBloq);
  };

  return (
    <div className="bloqueados-wrapper">
      {/* [TAG] Bloco de bloqueio por TAG */}
      <div className="bloqueados-form bloqueio-por-tag">
        <h3 className="bloqueados-titulo">Bloquear por TAG</h3>
        <div className="linha">
          <select
            value={tagSelecionada}
            onChange={(e) => {
              const v = e.target.value;
              setTagSelecionada(v);
              previewBloqueioPorTag(v);
            }}
          >
            <option value="">Selecione uma TAG</option>
            {tags.map((t) => (
              <option key={t.id} value={t.id}>{t.nome}</option>
            ))}
          </select>

          <button
            onClick={bloquearTodosDaTag}
            disabled={!tagSelecionada || bloqueandoTag || (previewTag && previewTag.total === 0)}
            className="btn-vermelho"
          >
            {bloqueandoTag ? 'Bloqueando...' : 'Bloquear TAG'}
          </button>
        </div>

        {/* Prévia */}
        {carregandoTagPreview ? (
          <p>Carregando prévia...</p>
        ) : previewTag ? (
          <div className="preview-tag-box">
            <strong>Leads encontrados: {previewTag.total}</strong>
            {previewTag.total > 0 && (
              <details>
                <summary>Ver lista</summary>
                <ul>
                  {previewTag.leads.slice(0, 50).map((l) => (
                    <li key={l.lead_id}>
                      {l.nome || '---'} — {formatarTelefoneBR(l.telefone)}
                    </li>
                  ))}
                </ul>
                {previewTag.leads.length > 50 && <small>...lista truncada (mostrando 50)</small>}
              </details>
            )}
          </div>
        ) : null}
      </div>

      {/* Bloco: bloquear por número/manual/lead */}
      <h3 className="bloqueados-titulo">Bloquear por Lead</h3>
      <div className="bloqueados-form selecionar-lead-form">
        <select
          value={novoNumero}
          onChange={(e) => setNovoNumero(e.target.value)}
        >
          <option value="">Selecione um lead para bloquear</option>
          {leads.map((lead) => (
            <option key={lead.id} value={lead.telefone}>
              {lead.nome} - {formatarTelefoneBR(lead.telefone)}
            </option>
          ))}
        </select>

        <input
          type="text"
          placeholder="Ou digite o número manualmente"
          value={novoNumero}
          onChange={(e) => setNovoNumero(e.target.value)}
          className="bloqueados-input"
        />

        <button onClick={handleAdicionar} className="btn-vermelho">
          Bloquear
        </button>
      </div>

      {carregando ? (
        <p>Carregando...</p>
      ) : bloqueados.length === 0 ? (
        <p>Nenhum número bloqueado.</p>
      ) : (
        <ul className="bloqueados-lista">
          {bloqueados.map((b) => {
            const lead = encontrarLeadPorTelefone(b.telefone);
            return (
              <li key={b.id} className="bloqueados-item">
                <div className="bloqueados-info">
                  <strong>{lead?.nome || '---'}</strong><br />
                  <span>{formatarTelefoneBR(b.telefone)}</span><br />
                  <small>Desde: {formatarDataBrasileira(b.data_bloqueio)}</small>
                </div>
                <button
                  onClick={() => handleRemover(b.telefone)}
                  className="bloqueados-remover"
                >
                  Remover
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}

export default BloqueadosIA;
